/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "blaster"
    }}>{`Blaster`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`Blaster`}</inlineCode>{` component is a wrapper for your entire application.
It does a few things:`}</p>
    <ul>
      <li parentName="ul">{`inserts the necessary global styles to make your application look its best`}</li>
      <li parentName="ul">{`provides a default theme to all components rendered within`}</li>
      <li parentName="ul">{`allows overriding and merging of theme styles`}</li>
    </ul>
    <h2 {...{
      "id": "using-the-default-theme"
    }}>{`Using the default theme`}</h2>
    <pre><code parentName="pre" {...{}}>{`  import React from "react";
  import { Blaster, Card } from "@blasterjs/core";

  export default () => (
    <Blaster>
      <Card bg="primary">
        Hello
      </Card>
      <Card bg="secondary">
        World
      </Card>
    </Blaster>
  ) ;
`}</code></pre>
    <h2 {...{
      "id": "overriding-the-default-theme"
    }}>{`Overriding the default theme`}</h2>
    <pre><code parentName="pre" {...{}}>{`  import React from "react";
  import { Blaster, Badge } from "@blasterjs/core";

  const newTheme = {
    colors: {
      primary: 'blue',
      secondary: 'red'
    }
  };

  export default () => (
    <Blaster theme={ newTheme }>
      <Card bg="primary">
        Hello
      </Card>
      <Card bg="secondary">
        World
      </Card>
    </Blaster>
  ) ;
`}</code></pre>
    <h3 {...{
      "id": "proptypes"
    }}>{`PropTypes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Prop`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`theme`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see default theme`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The theme to use for components within this tag. The theme object provided will be merged with the default theme`}</td>
        </tr>
      </tbody>
    </table>
    </MDXLayout>;
}

MDXContent.isMDXComponent = true;
  